app.controller('CIFFIN-CTRL', function ($scope, $rootScope, $routeParams, uibDateParser, deviceDetector, $timeout,
    $uibModal, $http, $window, $location, Upload, $q, $filter) {

    $scope.stage = 1;
    $scope.CIFInvestor = {};
    $scope.ktpPhoto = '';
    $scope.device = deviceDetector;
    $scope.append = '';

    $scope.counter = 6;

    $scope.series5 = [];
    //$scope.series7 = [];

    $scope.statusCamera = 'true';


    $scope.onTimeout = function () {
        $scope.counter--;
        var mytimeout
        if ($scope.counter > 0) {
            mytimeout = $timeout($scope.onTimeout, 1000);
        }
        else {
            console.log('capturing...', $scope.stage);
            $scope.$broadcast('ngWebcam_capture');
            //alert("Time is up!");
        }
    }



    $scope.reset = function () {
        $scope.counter = 5;
        mytimeout = $timeout($scope.onTimeout, 1000);
    }



    $scope.camfacing = 'env';
    $scope.ktpPhoto = '';

    $scope.KTPconfig = {
        viewerWidth: 300,
        viewerHeight: 300,
        outputWidth: 300,
        outputHeight: 300,
        delay: 5,
        shots: 3,
        countdown: 0,
        flashFallbackUrl: 'vendors/webcamjs/webcam.swf',
        //shutterUrl: 'shutter.mp3',
        flashNotDetectedText: 'Camera not found or use Chrome Browser'
    };

    $scope.KTPonCaptureComplete = function (src) {
        console.log('capturecomplete', $scope.stage);
        $scope.counter = 6;

        //if ($scope.stage == 5) {
        //    console.log("CAPTURE COMPLETE STAGE 5");
        //    $scope.series7 = [];
        //    for (var i = 0; i < src.length; i++) {
        //        $scope.series7.push(src[i]);
        //    }
        //    //$scope.series7 = src;
        //    $scope.submit();

        //}

        if ($scope.stage == 4) {
            console.log("CAPTURE COMPLETE STAGE 4");
            $scope.counter = 6;

            $scope.series5 = [];
            for (var i = 0; i < src.length; i++) {
                $scope.series5.push(src[i]);
            }
            $scope.submit();
            //$scope.changeStage(5);
        }


        //var el = document.getElementById('result');
        //var img = document.createElement('img');
        //img.src = src[$scope.KTPconfig.shots - 1];
        //img.width = 240;
        //img.height = 180;
        //el.appendChild(img);
    };


    $scope.KTPonLive = function (err) {
        console.log('live');
    };


    $scope.KTPonError = function (err) {
        //$log.error('webcamController.onError : ', err);
        $scope.statusCamera = '';
        console.log("Error Camera: " +err);
        $rootScope.AlertShowLoading('warning', err.message, 'Please Allowed Permission for camera and mic, or use other browser and Try Again', 0);
    };

    $scope.KTPonLoad = function () {
        // $log.info('ktp.onLoad');
        console.log('load');
    };

    $scope.KTPcapture = function () {
        $scope.$broadcast('ngWebcam_capture');
    };

    $scope.KTPon = function () {
        $scope.$broadcast('ngWebcam_on');
    };

    $scope.KTPoff = function () {
        $scope.$broadcast('ngWebcam_off');
        $scope.captureButtonEnable = false;
    };

    $scope.KTPremove = function () {
        $scope.ktpPhoto = '';
    }

    $scope.openCamera = function () {
        let message = 'KTP';
        let url = 'ModalCamera.html';
        let ctrl = 'CameraController';


        //if ($scope.device.isMobile())
        //{
        //    url = 'ModalBrowse.html';
        //    ctrl = 'BrowseController';
        //    $scope.append = 'data:image/png;base64,';
        //}

        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: url,
            controller: ctrl,
            size: 'md',
            resolve: {
                items: function () {
                    return message;
                }
            }
        });
        modalInstance.result.then(function (resolvedResponse) {
            //console.log('ktp',resolvedResponse);
            if (resolvedResponse) {
                $scope.ktpPhoto = resolvedResponse;
            }
        }, function () { });
    };

    $scope.KTPremove = function () {
        $scope.ktpPhoto = '';
    };


    var allPromise = $q.all([
         $http({
             method: 'POST',
             url: 'service/client.svc/retrieveSession',
         }).then(function (data) {
             if (!data.data.d) {
                 $http({
                     method: 'GET',
                     url: 'service/client.svc/SignOut',
                 }).then(function (data) {
                     if (data.data.d == true) {
                         $window.location.href = "#/login";
                         $window.location.reload();
                     }
                 }, function (error) { })
             }
             else
                 $scope.currentUser = data.data.d;
         }, function (error) { }),


    ]);


    $scope.checkConnection = function (newstage) {
        $rootScope.AlertShowLoading('warning', 'Check connection, Please wait...', '', 0);
        //check connection=
        var imageAddr = "/img/31120037-5mb.jpg";
        var downloadSize = 4995374; //bytes

        function InitiateSpeedDetection() {
            var msg = "Check connection, please wait...";
            $rootScope.AlertShowLoading('warning', msg, '', 1);
            window.setTimeout(MeasureConnectionSpeed, 1);
        };

        if (window.addEventListener) {
            //window.addEventListener('load', InitiateSpeedDetection, false);
            window.setTimeout(MeasureConnectionSpeed, 1);
        } else if (window.attachEvent) {
            window.attachEvent('onload', InitiateSpeedDetection);
        }

        function MeasureConnectionSpeed() {
            var startTime, endTime;
            var download = new Image();
            download.onload = function () {
                endTime = (new Date()).getTime();
                showResults();
            }

            download.onerror = function (err, msg) {
                $rootScope.AlertShowLoading('warning', 'Connection lost, or error connection', '', 0);
                //console.log("Invalid image, or error downloading");
            }

            startTime = (new Date()).getTime();
            var cacheBuster = "?nnn=" + startTime;
            download.src = imageAddr + cacheBuster;

            function showResults() {
                var duration = (endTime - startTime) / 1000;
                var bitsLoaded = downloadSize * 8;
                var speedBps = (bitsLoaded / duration).toFixed(2);
                var speedKbps = (speedBps / 1024).toFixed(2);
                var speedMbps = (speedKbps / 1024).toFixed(2);
                console.log([
                    "Your connection speed is:",
                    speedBps + " bps",
                    speedKbps + " kbps",
                    speedMbps + " Mbps"
                ]);
                if (parseInt(speedKbps) <= '100') {
                    $rootScope.GlobalAlert('warning', 'Low Connection', 'Try to change network and try again.', 0);
                    console.log('low connection')
                    $scope.stage = newstage - 1;
                }
            }
        }
    }

    $scope.changeStage = function (newstage) {
        $scope.stage = newstage;
        
        if ($scope.stage == 4) {
            $scope.checkConnection(newstage);
            $scope.$broadcast('ngWebcam_camUsr');
            $scope.camfacing = 'usr'
            swal.fire({
                imageUrl: 'img/guidance/selfie.png',
                imageAlt: 'E-KTP',
                background: '#1c252c',
                width: '600px',
                allowEscapeKey: false,
                allowOutsideClick: false,
                animation: false,
                onOpen: () => {
                    swal.showLoading()
                    setTimeout(() => { swal.hideLoading() }, 3000)
                },
            }).then((result) => {
                if (!result.dismiss) {
                    
                }
            })


        }

        //if ($scope.stage == 5) {
        //    $scope.$broadcast('ngWebcam_restart');
        //    $scope.$broadcast('ngWebcam_camUsr');
        //    $scope.camfacing = 'usr'
        //    swal({
        //        imageUrl: 'img/verification/step2.png',
        //        imageAlt: 'E-KTP',
        //        background: '#1c252c',
        //        width: '600px',
        //        allowEscapeKey: false,
        //        allowOutsideClick: false,
        //        animation: false,
        //        onOpen: () => {
        //            swal.showLoading()
        //            setTimeout(() => { swal.hideLoading() }, 3000)
        //        },
        //    }).then((result) => {
        //        if (!result.dismiss) {
        //            $scope.counter = 6;
        //            var mytimeout = $timeout($scope.onTimeout, 1000);
        //            //console.log('user read the important message')
        //        }
        //    })


        //}
    }


    $scope.takeCamera = function () {
        $scope.statusCamera = 'true';
        $scope.counter = 6;
        var mytimeout = $timeout($scope.onTimeout, 1000);
    }


    allPromise.then(function () {

        $http({
            method: 'GET',
            url: 'service/client.svc/getCIF',
        }).then(function (data) {
            if (data.data.d != null) {
                var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;
                $scope.CIFInvestor.Stage = 4;

            } // END IF data.data.d
        }, function (error) { });
    });



    $scope.submit = function () {
        $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
        $http({
            method: 'POST',
            url: 'service/client.svc/ImageVerification',
            data:
            {
                imageData: {
                    series5: $scope.series5,
                    //series7: $scope.series7,
                }
            }
        }).then(function (data) {
            swal('success', 'Permohonan pembukaan rekening efek Anda telah kami terima. Silahkan cek email', 'success').then(function () {
                $window.location.href = "#/dashboard";
            });

        }, function (error) {
            swal('Error', 'error - Please check your connection' + error, 'error');
        });
    }

    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: 'service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };



});

